import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, NavigationCancel, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthBaseService } from 'src/app/services/auth/auth-base.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  url: string = '';

  constructor(
    private authBaseService: AuthBaseService,
    private router: Router,
  ) { 
    this.router.events.subscribe((res) => {

      if (res instanceof NavigationCancel) {
          this.url = res.url;
      }
  });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.authBaseService.getLocalStorageToken())
      return true;
    else {
      this.authBaseService.setCallbackUrl(this.url)
      this.router.navigateByUrl('login');
      return false;
    }
  }

}
